import CustomerSignUpArticle from './CustomerSignUpArticle';

export { default as CustomerSignUpArticleTheme } from './CustomerSignUpArticle.style';
export default CustomerSignUpArticle;
